import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import ReusableModal from "../../Components/Modal";
import { Modal } from "react-bootstrap";
import moment from "moment";

const Coupons = () => {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState({});
  const [catId, setCatId] = useState({});

  const closeModal = () => {
    setCatId({});
    setShowModal(false);
  };
  useEffect(() => {
    fetchCategory(pageData.currentPage, entries);
  }, [pageData.currentPage, entries]);

  const fetchCategory = async (current, count) => {
    setLoading(true);
    try {
      const getCategoryList = await axiosHttp.get(
        `coupons?page=${current}&count=${count}`
      );
      if (getCategoryList.status === 200) {
        let data = getCategoryList?.data?.data;
        let page = getCategoryList?.data?.meta;
        setPageData({
          currentPage: page?.currentPage || 1,
          totalPages: page?.lastPage || 1,
        });
        setCategoryList(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setCategoryList([]);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      setLoading(false);
    }
  };

  const validateForm = () => {
    if (catId?.code === undefined || catId.code === "") {
      setError({ ...error, code: "Coupon code required" });
    } else if (catId?.type === undefined || catId.type === "") {
      setError({ ...error, type: "Type of coupon code required" });
    } else if (
      catId?.valid_start_date === undefined ||
      catId.valid_start_date === ""
    ) {
      setError({ ...error, valid_start_date: "Start date required" });
    } else if (
      catId?.valid_end_date === undefined ||
      catId.valid_end_date === ""
    ) {
      setError({ ...error, valid_end_date: "End date required" });
    } else if (catId?.usage_limit === undefined || catId.usage_limit === "") {
      setError({ ...error, usage_limit: "Usage Limit required" });
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const postCategory = await axiosHttp.post(
        catId._id ? `coupons/${catId._id}` : `coupons`,
        {
          code: catId?.code,
          type: catId?.type,
          percentage: catId?.percentage,
          fixedAmount: catId?.fixedAmount,
          validStartDate: catId?.valid_start_date,
          validEndDate: catId?.valid_end_date,
          usageLimit: catId?.usage_limit,
        }
      );
      if (postCategory.status === 200 || postCategory.status === 201) {
        fetchCategory(pageData.currentPage, entries);
        setShowModal(false);
        setCatId({});
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 422) {
        toast.error(error.response.data.message);
        setShowModal(false);
        fetchCategory(pageData.currentPage, entries);
      }
      setCategoryList([]);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteCategory = await axiosHttp.delete(`coupons/${id}`);
      if (deleteCategory.status === 200) {
        setLoading(true);
        toast.success(deleteCategory.data.message);
        fetchCategory(pageData.currentPage, entries);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError({ ...error, [name]: "" });
    setCatId({ ...catId, [name]: value });
  };

  const updateEntries = (e) => {
    let entryNumber = Number(e.target.value);
    setEntries(entryNumber);
  };

  const handleModal = (cat) => {
    setCatId(cat);
    setShowModal(true);
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <h4 className="title mb-5">Coupon Details</h4>

          <div className="row">
            <div className="col-md-5">
              <h5 className="head">Coupon List</h5>
            </div>
            <div className="col-md-7 text-right">
              <button
                type="button"
                className="btn btn-primary "
                onClick={() => setShowModal(true)}
              >
                Add Coupon
              </button>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={updateEntries}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th className="border-right-0 ">
                    <input
                      type="checkbox"
                      className="form-control check-box "
                    />
                  </th>
                  <th>Coupon</th>
                  <th>Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categoryList.length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {categoryList.length > 0 &&
                  categoryList.map((admin) => {
                    return (
                      <tr key={admin.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td className="border-right-0 ">{admin?.code}</td>
                        <td className="border-right-0 ">{admin?.type}</td>
                        <td className="border-right-0 ">
                          {admin?.valid_start_date
                            ? moment(admin?.valid_start_date).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </td>
                        <td className="border-right-0 ">
                          {admin?.valid_end_date
                            ? moment(admin?.valid_end_date).format("DD/MM/YYYY")
                            : "-"}
                        </td>
                        <td>
                          <span>
                            <FontAwesomeIcon
                              icon={faEdit}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                              onClick={() => handleModal(admin)}
                            />
                          </span>
                          <span onClick={() => deleteHandler(admin._id)}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {pageData.totalPages > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData.totalPages}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={pageData.currentPage - 1}
            />
          )}
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title={catId?._id ? "Update Coupon" : "Add Coupon"}
        size="md"
      >
        <Modal.Body>
          <div className="form-group input-group mb-5 row">
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <input
                className="form-control"
                type="text"
                value={catId?.code || ""}
                name="code"
                onChange={handleChange}
              />
              <span>Code</span>
              {error.code && <p className="form-error">{error.code}</p>}
            </label>
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <select
                className="form-control entry-select ml-2 mr-2"
                value={catId?.type}
                name="type"
                onChange={handleChange}
              >
                <option value="">Choose</option>
                <option value="percentage">Percentage</option>
                <option value="fixed">Fixed</option>
              </select>
              <span>Type</span>
              {error.type && <p className="form-error">{error.type}</p>}
            </label>
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <input
                className="form-control"
                type="text"
                value={catId?.percentage || ""}
                name="percentage"
                onChange={handleChange}
              />
              <span>Percentage</span>
            </label>
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <input
                className="form-control"
                type="text"
                value={catId?.fixedAmount || ""}
                name="fixedAmount"
                onChange={handleChange}
              />
              <span>Fixed Amount</span>
            </label>
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <input
                className="form-control"
                type="date"
                value={catId?.valid_start_date || ""}
                name="valid_start_date"
                onChange={handleChange}
              />
              <span>Start Date</span>
              {error.valid_start_date && (
                <p className="form-error">{error.valid_start_date}</p>
              )}
            </label>{" "}
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <input
                className="form-control"
                type="date"
                value={catId?.valid_end_date || ""}
                name="valid_end_date"
                onChange={handleChange}
              />
              <span>End Date</span>
              {error.valid_end_date && (
                <p className="form-error">{error.valid_end_date}</p>
              )}
            </label>
            <label className="has-float-label col-md-6 mb-3 coupon-input">
              <input
                className="form-control"
                type="number"
                value={catId?.usage_limit || ""}
                name="usage_limit"
                onChange={handleChange}
              />
              <span>Usage Limit</span>
              {error.usage_limit && (
                <p className="form-error">{error.usage_limit}</p>
              )}
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Footer className="mt-4 justify-content-center">
            <button
              type="button"
              className="btn btn-outline-primary modal-btn"
              onClick={validateForm}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary modal-btn"
              onClick={closeModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal.Footer>
      </ReusableModal>
    </div>
  );
};

export default Coupons;
